// extracted by mini-css-extract-plugin
module.exports = {"comp":"PowerSolution_comp__MO181","ani-fade-in-opacity":"PowerSolution_ani-fade-in-opacity__ipsI7","ani-fade-in-width":"PowerSolution_ani-fade-in-width__Xe_sD"};